// extracted by mini-css-extract-plugin
var _1 = "Zt6FvcYEcEcuXleu5uXe";
var _2 = "YtXQF7V2E_KkbTfKdThJ";
var _3 = "v0nS5_Kd7at1kCU7sRKA";
export { _1 as "employees", _2 as "multiple", _3 as "negative" }
